/**
 * Forza Material Design (mode=md) su ogni piattaforma — inclusa iOS/iPadOS Capacitor.
 * Evita lo stile Cupertino (font SF, controlli nativi, margini iOS-only).
 */

export const UI_MODE = 'md' as const

const MD_FONT_STACK =
  "Roboto, 'Roboto Flex', 'Noto Sans', 'Segoe UI', Helvetica, Arial, sans-serif"

/** Stack Material — Roboto prima di -apple-system / SF. */
export function materialFontStack(): string {
  return MD_FONT_STACK
}

export function forceMaterialDesignMode(): void {
  const root = document.documentElement
  root.setAttribute('mode', UI_MODE)
  root.classList.add('md', 'plt-md', 'md-mode')
  root.classList.remove('ios', 'ios-mode', 'plt-ios', 'hydrated')
  root.style.setProperty('--font-ui', MD_FONT_STACK)
  // Ionic-compat: alcuni componenti leggono ion-mode / data-mode
  root.dataset.mode = UI_MODE
  try {
    localStorage.setItem('ionic_mode_preference', UI_MODE)
  } catch {
    /* private mode */
  }
}
